var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLiquidations({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "b",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 33.03 18.37",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.53,3.32l-11.57,13.15c-.69,.79-1.66,1.22-2.71,1.22h0c-1.02,0-1.95-.41-2.63-1.15l-1.82-1.71c-.09-.09-.17-.18-.24-.28l-2.28,2.59c-.69,.79-1.66,1.23-2.71,1.23h0c-1.05,0-2.02-.44-2.71-1.23L.5,11.03c-.73-.83-.65-2.09,.19-2.82,.83-.73,2.09-.64,2.82,.19l5.06,5.77L19.84,1.35c.73-.83,1.99-.91,2.82-.18,.83,.73,.91,1.99,.18,2.82l-6.72,7.64c.15,.08,.29,.17,.41,.29l1.69,1.59L29.53,.68c.73-.83,1.99-.91,2.82-.18s.91,1.99,.18,2.82Z",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLiquidations);
export default __webpack_public_path__ + "static/media/liquidations.b5a8eeb2ac7e161cf6f87cc94284e473.svg";
export { ForwardRef as ReactComponent };